import React from "react"
import useBirlExerciseEntryCollectionQuery from 'generated/api/birl/exercise_entries/useBirlExerciseEntryCollectionQuery'
import Spinning from 'app/components/Spinning'
import { format } from 'date-fns'


export default ({ exerciseId, weightSignature }) => {
  const { isPending, data: { birlExerciseEntries, noMatches } = {} } = useBirlExerciseEntryCollectionQuery({
    query: {
      birl_exercise_id: exerciseId,
      weight_signature: weightSignature
    }
  })

  if(isPending) return <Spinning />

  return <div className="mb-d">
           { birlExerciseEntries.length > 0 && <div className="text-sm text-gray-800"> Entries </div> }
           {
             birlExerciseEntries.map((entry) => {
               return <div key={ entry.id } className="frow items-center">
                        <div className="darkest-gray-transparent-box text-xs px-d rounded-left h-10 frow items-center justify-end w-40">{ format(entry.executedAt, 'E, MMM dd') }</div>
                        <div className= { clsx("gray-transparent-box px-d rounded-right h-10 flex-1", { 'text-sm pt-1': noMatches }) } >
                          {
                            noMatches ? entry.full : entry.reps
                          }
                        </div>
                      </div>
             })
           }
         </div>
}
